

import { Component, Vue, Watch } from 'vue-property-decorator';
import ApiRoutes from '@/logic/ApiRoutes';
import io from 'socket.io-client';
import GlobalEvents from '@/logic/GlobalEvents';

/**
 * Renderless component for socket feed
 */
@Component
export default class DIListener extends Vue {

    private socket: any;
    // Is the listener active
    private active: boolean = false;

    get profile() {
        return this.$store.getters['settings/getProfile'];
    }

    public activate() {

        // if (!this.active) {
        this.socket.emit('join_profile', this.profile);
        this.active = true;
        // }
    }

    public deactivate() {

        // if (this.active) {
        this.socket.emit('leave_profile', this.profile);
        this.active = false;
        // }
    }

    @Watch('profile')
    private onProfileChanged(newProfile: number, oldProfile: number) {
        this.socket.emit('leave_profile', oldProfile);
        this.socket.emit('join_profile', newProfile);
    }

    private beforeMount() {
        this.socket = io(ApiRoutes.SOCKET_ADDRESS);
        this.socket.on('next_chunk', (data: any) => {
            this.$store.dispatch('performance/receiveDisplayItem', data);
        });
        this.socket.on('prev_chunk', (data: any) => {
            this.$store.dispatch('performance/retractDisplayItem', data);
        });
        this.socket.on('reset_project', (data: any) => {
            this.$store.commit('performance/clearDisplayItems');
        });

        this.checkConnection();

        // Register open/close listener
        GlobalEvents.$on('enter-performance', this.activate);
        GlobalEvents.$on('leave-performance', this.deactivate);

        // Attach listener for pull-refresh
        GlobalEvents.$on('local-refresh', () => {
            this.checkConnection();
        });

        // Attach listener for visibilitychange
        window.addEventListener('visibilitychange', () => {
            this.checkConnection();
        });
    }

    private checkConnection() {
        // if (!this.active && this.$store.getters['settings/inPerformance']) {
        if (this.$router.currentRoute.name &&
                (['performance', 'performance-direct'].includes(this.$router.currentRoute.name))) {
            this.deactivate();
            this.socket.disconnect().connect();
            this.activate();
        }
        // }
    }

    // Leave sockets profile on exiting page
    private beforeDestroy() {
        this.deactivate();
    }
}
